import {
  IPsp,
  IPspDetails,
  IPspParameter,
  IPspParameterData,
  TPspData,
  TPspDetailsData,
} from 'api/psp/types';
import { TRANSACTIONS_TYPE } from 'api/transactions/constants';

export const normalizePsp = (data: TPspData): IPsp => {
  return {
    adapterCode: (data?.adapterCode as string) || '',
    builderProvider: !!data?.builderProvider,
    countryCodes: (data?.countryCodes as string[]) || [],
    countryGroups: (data?.countryGroups as string[]) || [],
    cryptoExchange: (data?.cryptoExchange as string) || '',
    email: (data?.email as string) || '',
    enabled: !!data?.enabled,
    fx: (data?.fx as string) || '',
    gambling: (data?.gambling as string) || '',
    id: (data?.id as number) || 0,
    isPartner: !!data?.isPartner,
    name: (data?.name as string) || '',
    notes: (data?.notes as string) || '',
    operations: (data?.operations as TRANSACTIONS_TYPE[]) || [],
    paymentMethod: (data?.paymentMethod as string) || '',
    pciDssCompliant: !!data?.pciDssCompliant,
    pciDssExpirationDate: (data?.pciDssExpirationDate as string) || '',
    refPercent: (data?.refPercent as string) || '',
  };
};

const normalizePspParameters = (data: IPspParameterData): IPspParameter => {
  return {
    comment: (data?.comment as string) || '',
    dataType: (data?.dataType as string) || '',
    id: (data?.id as number) || 0,
    name: (data?.name as string) || '',
    value: (data?.value as string) || '',
    visibility: {
      bankTerminal: !!data?.visibility?.bankTerminal,
      terminalLink: !!data?.visibility?.terminalLink,
    },
  };
};

export const normalizePspDetails = (data: TPspDetailsData): IPspDetails => {
  return {
    bankConditionsBlock: {
      countries: (data?.bankConditionsBlock?.countries as string[]) || [],
      countryGroups: (data?.bankConditionsBlock?.countryGroups as string[]) || [],
      cryptoExchange: (data?.bankConditionsBlock?.cryptoExchange as string) || '',
      fx: (data?.bankConditionsBlock?.fx as string) || '',
      gambling: (data?.bankConditionsBlock?.gambling as string) || '',
      isPartner: !!data?.bankConditionsBlock?.isPartner,
      notes: (data?.bankConditionsBlock?.notes as string) || '',
      refPercent: (data?.bankConditionsBlock?.refPercent as string) || '',
    },
    bankInfoBlock: {
      adapterCode: (data?.bankInfoBlock?.adapterCode as string) || '',
      adapterCodeHash: (data?.bankInfoBlock?.adapterCodeHash as string) || '',
      builderProvider: !!data?.bankInfoBlock?.builderProvider,
      email: (data?.bankInfoBlock?.email as string) || '',
      enabled: !!data?.bankInfoBlock?.enabled,
      id: (data?.bankInfoBlock?.id as number) || 0,
      name: (data?.bankInfoBlock?.name as string) || '',
      operation: (data?.bankInfoBlock?.operation as TRANSACTIONS_TYPE[]) || [],
      paymentMethod: (data?.bankInfoBlock?.paymentMethod as string) || '',
      pciDssCompliant: !!data?.bankInfoBlock?.pciDssCompliant,
      pciDssExpirationDate: data?.bankInfoBlock?.pciDssExpirationDate || '',
    },
    bankParametersBlockView:
      data?.bankParametersBlockView?.map(normalizePspParameters) || [],
  };
};
